import { dataset, findMany, on, jsonParse } from '../helpers';

// Maps the legacy category/action pairs onto GA4 event names. Only contact clicks are key
// events; dialog open/close and generic clicks stay as engagement noise.
const ga4EventName = ({ category, action, label }) => {
    if (category === 'Contact' && action === 'Single Click') {
        return String(label || '').includes('@') ? 'email_click' : 'phone_click';
    }
    if (category === 'Forms') {
        return 'generate_lead';
    }
    return null;
};

export const GaEvent = ({ name, category, action, event, label }) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event || 'CraftEvent',
        eventCategory: category || 'Generic Event',
        eventAction: action || 'Unknown',
        eventLabel: name || label || null,
    });

    const ga4Name = ga4EventName({ category, action, label: name || label });
    if (ga4Name && typeof window.gtag === 'function') {
        window.gtag('event', ga4Name, { event_category: category, event_label: name || label || undefined });
    }
};

export const formEvent = ({ name, category, action, event }) => {
    return GaEvent({ name, action, event, category: category || 'Forms' })
}

export const listenForClickEvents = () => {
    findMany('[data-event]').forEach(button => {
        if (button.listeningForClicks) {
            return false;
        }

        const config = jsonParse(dataset(button, 'event'));

        const event = {
            category: 'Clicks',
            ...(typeof config === 'object' ? config : { name: config }),
        };

        let watchingForDoubleClick;

        on('click', () => {
            if (!watchingForDoubleClick) {
                watchingForDoubleClick = setTimeout(() => {
                    GaEvent({ action: 'Single Click', ...event })
                    watchingForDoubleClick = null;
                }, 500);
            }
        }, button)

        on('dblclick', () => {
            GaEvent({...event, action: 'Double Click'})
            clearTimeout(watchingForDoubleClick);
            watchingForDoubleClick = null;
        }, button)

        on('contextmenu', () => {
            GaEvent({...event, action: 'Right Click'})
        }, button)

        button.listeningForClicks = true;
    })
}

listenForClickEvents();

setTimeout(() => {
    listenForClickEvents();
}, 2000)
